import toast, { CheckmarkIcon, ErrorIcon } from "react-hot-toast";
import { Column } from "react-table";
import IconExternalLink from "../../../Common/Icons/IconExternalLink";
import Switch from "../Form/Switch";
import { ILessonDataRow } from "./Table";

export const LessonColumns: Column<ILessonDataRow>[] = [
  {
    Header: "Level",
    accessor: "level",
  },
  {
    Header: "Topic",
    accessor: "topic",
  },
  {
    Header: "Module",
    accessor: "module",
  },
  {
    Header: "Date Created",
    accessor: "date_created",
  },
  {
    Header: "Created By",
    accessor: "created_by",
  },
  {
    Header: "Completed",
    accessor: "completed",
    Cell: ({ value, row }) => (value ? <CheckmarkIcon /> : <ErrorIcon />),
  },
  {
    Header: "Details",
    accessor: "notion_url",
    Cell: ({ value, row }) => (
      <button
        onClick={(e) => {
          e.stopPropagation();
          window.open(value);
        }}
      >
        <IconExternalLink />
      </button>
    ),
  },
];
